import React from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import energyIcon from "../../../../../assets/design-revamp-company/company-detail-headers/energy-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";

const EnergyIcon = () => (
  <img src={energyIcon} alt="Energy Icon" width={76} height={76} />
);

const EnergyHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  totalEnergy,
  totalObjEnergy,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <CategoryComponent
      show={show}
      className={`energy-category ${className || ""}`}
      leftBoxProps={{
        icon: <EnergyIcon />,
        title: t("ENERGY"),
        description: t("ENERGY_INTRO"),
        scopes: [
          { scope: "Scope 1", filled: true },
          { scope: "Scope 2", filled: false },
        ],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_ENERGY"),
            showInfoIcon: true,
            infoText: t("TOTAL_SOLD_ENERGY_TIP"),
            infoText1: t("TOTAL_QTY_WASTED_TIP"),
            items: [
              {
                subtitle: t("SOLD_ENERGY"),
                subitems: [
                  {
                    label: "kWh",
                    value: handleToFixedNum(
                      totalEnergy,
                      totalEnergy?.total_sold_kwh
                    ),
                  },
                  {
                    label: "MJ",
                    value: handleToFixedNum(
                      totalEnergy,
                      totalEnergy?.total_sold_mj
                    ),
                  },
                ],
              },
              {
                subtitle: t("WASTE_ENERGY"),
                subitems: [
                  {
                    label: "kWh",
                    value: handleToFixedNum(
                      totalEnergy,
                      totalEnergy?.total_wasted_kwh
                    ),
                  },
                  {
                    label: "MJ",
                    value: handleToFixedNum(
                      totalEnergy,
                      totalEnergy?.total_wasted_mj
                    ),
                  },
                ],
              },
            ],
          },
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjEnergy,
                      totalObjEnergy?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${
                  totalObjEnergy
                    ? handleToFixedNum(
                        totalObjEnergy,
                        totalObjEnergy?.total_emissions
                      )
                    : "xx"
                } (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjEnergy,
                      totalEnergy?.total_scope_2
                    ),
                    scopes: ["Scope 2"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjEnergy,
                      totalEnergy.total_scope_1
                    ),
                    scopes: ["Scope 1"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjEnergy,
                      totalEnergy?.total_carbon_wasted_tonnes
                    ),
                    scopes: ["Outside"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjEnergy?.updated_at
          ? formatDate(totalObjEnergy?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default EnergyHeader;
